const updateProductItem3 = (componentRegistry) => {
  componentRegistry.useComponentPlugin("ProductItem", {
    name: "Add SKU and specsheet to product card",
    enabled: true,
    apply: () => ({
      afterRender(element) {
        try {
          let productData =
            element.getParams()?.props?.product ||
            element.getParams()?.props?.productData ||
            element.getParams()?.props?.data;
          let productItem = document.querySelector(
            '[data-product-id="' + productData.id + '"]'
          );
          if (!productItem) return;

          // Start boost 503968
          if (!productItem.querySelector(".boost-sd__custom-label-container")) {
            productItem
              .querySelector(
                ".boost-sd__product-image-column.boost-sd__product-image-column--in-top.boost-sd__product-image-column--left"
              )
              .insertAdjacentHTML(
                "beforeend",
                `<div class="boost-sd__custom-label-container"></div>`
              );
          }
          if (boostSDThemeSettings) {
            //declared in theme.liquid
            const saleTagLabelLimit =
              getSaleTagLabelLimit(boostSDThemeSettings);
            let saleLabelTagFound = false;

            for (let i = 0; i <= saleTagLabelLimit; i++) {
              const currentTagLabelIsActive =
                boostSDThemeSettings["tag" + i + "_active"];
              const currentTagLabelText =
                boostSDThemeSettings["tag" + i + "_text"];
              const tagToCheck = "TAG" + i;
              if (
                currentTagLabelIsActive &&
                currentTagLabelText &&
                productData.tags.includes(tagToCheck) &&
                !saleLabelTagFound
              ) {
                saleLabelTagFound = true;
                const saleTagLabelHTML = `<div class="boost-sd__custom-label boost-sd__custom-sale-label label-${tagToCheck}">${currentTagLabelText}</div>`;
                if (
                  !productItem.querySelector(
                    `.boost-sd__custom-sale-label.label-${tagToCheck}`
                  ) &&
                  productItem.querySelector(".boost-sd__custom-label-container")
                ) {
                  productItem
                    .querySelector(".boost-sd__custom-label-container")
                    .insertAdjacentHTML("beforeend", saleTagLabelHTML);
                }
                break;
              }
            }
          }

          // End boost 503968
          if (productData.percent_sale_min > 0) {
            const saleBadgeBottom = `<div class="product-card__badge-list-price"><on-sale-badge discount-mode="percentage" class="badge badge--on-sale">-${productData.percent_sale_min}%</on-sale-badge></div>`;
            const saleBadgeTopLeft = `<div class="boost-sd__custom-label boost-sd__custom-sale-label label-sale">${productData.percent_sale_min}% Off</div>`;
            const productPriceWrapper = productItem.querySelector(
              ".boost-sd__product-price-wrapper"
            );
            if (
              productPriceWrapper &&
              !productItem.querySelector(".product-card__badge-list-price")
            ) {
              productPriceWrapper.insertAdjacentHTML(
                "beforeend",
                saleBadgeBottom
              );
            }
            if (
              productItem.querySelector(".boost-sd__custom-label-container") &&
              !productItem.querySelector(
                `.boost-sd__custom-label.boost-sd__custom-sale-label.label-sale`
              )
            ) {
              productItem
                .querySelector(".boost-sd__custom-label-container")
                .insertAdjacentHTML("beforeend", saleBadgeTopLeft);
            }
          }

          if (productData.tags.includes("pre-sale")) {
            const preSaleLabel = `<span class="boost-sd__custom-label boost-sd__custom-pre-sale-label">Pre Sale</span>`;
            if (
              !productItem.querySelector(".boost-sd__custom-pre-sale-label") &&
              productItem.querySelector(".boost-sd__custom-label-container")
            ) {
              productItem
                .querySelector(".boost-sd__custom-label-container")
                .insertAdjacentHTML("beforeend", preSaleLabel);
            }
          }
          if (productData.tags.includes("local brands")) {
            const onlineOnlyLabel = `<span class="boost-sd__custom-label boost-sd__custom-local-brands-label">Online Only</span>`;
            if (
              !productItem.querySelector(".boost-sd__custom-local-brands-label") &&
              productItem.querySelector(".boost-sd__custom-label-container")
            ) {
              productItem
                .querySelector(".boost-sd__custom-label-container")
                .insertAdjacentHTML("beforeend", onlineOnlyLabel);
            }
          }
        } catch (e) {
          console.log("error: ", e);
        }
      },
    }),
  });
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  updateProductItem3,
]);

function getSaleTagLabelLimit(settings) {
  let tagLimit = 0;
  for (const key in settings) {
    if (settings.hasOwnProperty(key)) {
      // Check if the key matches the pattern 'tag[number]_active'
      const match = key.match(/^tag(\d+)_active$/);
      if (match) {
        const number = parseInt(match[1], 10);
        if (number > tagLimit) {
          tagLimit = number;
        }
      }
    }
  }
  return tagLimit;
}
